import React from "react";

export default React.createContext({ forceUpperCase: false });
